import React, { MouseEventHandler } from 'react';
import { Box, Button } from '@mui/material';
import styles from './bblButton.module.css';
import { useSound } from '../soundEffect/soundEffect';

type ButtonSize = 'large' | 'medium' | 'small';

type ButtonColor = 'primary' | 'secondary' | 'white' | 'ghost' | 'red';

interface BblButtonProps {
  size: ButtonSize;
  color: ButtonColor;
  children?: string | JSX.Element;
  disabled?: boolean; // DEFAULT: false
  iconLeft?: JSX.Element; // DEFAULT: undefined
  iconRight?: JSX.Element; // DEFAULT: undefined
  darkMode?: boolean; // DEFAULT: false
  iconOnly?: boolean; // DEFAULT: false
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  backButton?: boolean;
  mute?: boolean;
  fullWidth?: boolean;
}
const BblButton = (props: BblButtonProps): JSX.Element => {
  let buttonClassName = `${styles.button} `;
  let buttonLabelClassName = `${styles.buttonLabelBase} `;
  let buttonIconClassName = ``;
  // BUTTON SIZE
  switch (props.size) {
    case 'large':
      buttonClassName += ` ${styles.largeButton} `;
      buttonIconClassName += ` ${styles.largeButtonIconBox} `;
      break;
    case 'small':
      buttonClassName += ` ${styles.smallButton} `;
      buttonIconClassName += ` ${styles.smallButtonIconBox} `;
      break;
    case 'medium':
    default:
      // NOT USING NOW, USE LARGE AS NOW
      buttonClassName += ` ${styles.largeButton} `;
      buttonIconClassName += ` ${styles.largeButtonIconBox} `;
      break;
  }

  // BUTTON COLOR
  switch (props.color) {
    case 'secondary':
      buttonClassName += ` ${styles.secondary} `;
      buttonLabelClassName += ` ${styles.secondaryLabel} `;
      buttonIconClassName += ` ${styles.secondaryIcon} `;
      break;
    case 'white':
      buttonClassName += ` ${styles.white} `;
      buttonLabelClassName += ` ${styles.whiteLabel} `;
      buttonIconClassName += ` ${styles.whiteIcon} `;
      break;
    case 'ghost':
      buttonClassName += ` ${styles.ghost} `;
      buttonLabelClassName += ` ${styles.ghostLabel} `;
      buttonIconClassName += ` ${styles.ghostIcon} `;
      break;
    case 'red':
      buttonClassName += ` ${styles.red} `;
      buttonLabelClassName += ` ${styles.primaryLabel} `;
      buttonIconClassName += ` ${styles.primaryIcon} `;
      break;
    case 'primary':
    default:
      buttonClassName += ` ${styles.primary} `;
      buttonLabelClassName += ` ${styles.primaryLabel} `;
      buttonIconClassName += ` ${styles.primaryIcon} `;
      break;
  }

  // ICON ONLY BUTTON
  switch (props.iconOnly) {
    case true:
      buttonClassName += ` ${styles.iconOnly} `;
      buttonClassName += ` ${styles.iconOnly} `;
      break;
    case false:
    default:
      break;
  }

  if (props.disabled) {
    buttonClassName += ` ${styles.disabled} `;
    buttonLabelClassName += ` ${styles.disabledLabel} `;
    buttonIconClassName += ` ${styles.disabledIcon} `;
  }

  if (props.fullWidth) {
    buttonClassName += ` ${styles.fullWidth} `;
  }

  const [normalSound] = props.mute
    ? [(): void => {}]
    : useSound(
        'assets/audio/Sound effect/1. basic click/1. select/mobile click back.wav',
      );

  const [backSound] = props.mute
    ? [(): void => {}]
    : useSound(
        'assets/audio/Sound effect/1. basic click/2. back:close button/click casual digital.wav',
      );

  const onClick = (event: React.MouseEvent<HTMLButtonElement>): void => {
    if (props.backButton === true) {
      backSound();
    } else {
      normalSound();
    }

    props.onClick?.(event);
  };

  return (
    <button
      className={`${buttonClassName}`}
      onClick={onClick}
      disabled={props.disabled}
    >
      <Box className={`${buttonLabelClassName}`}>
        {props.iconLeft ? (
          <Box className={`${buttonIconClassName}`}>{props.iconLeft}</Box>
        ) : null}
        {props.iconOnly ? null : <span>{props.children}</span>}
        {props.iconRight ? (
          <Box className={`${buttonIconClassName}`}>{props.iconRight}</Box>
        ) : null}
      </Box>
    </button>
  );
};

export default BblButton;
